<template>
  <div class="container">
    <h2 class="mb-4">Reporte de Observaciones por Planilla</h2>

    <div v-if="loading">Cargando...</div>
    <div v-else-if="error" class="alert alert-danger">{{ error }}</div>
    <div v-else>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>ID</th>
            <th>Descripción</th>
            <th>Observación</th>
            <th>Tipo</th>
            <th>Planilla</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in observaciones" :key="item.idPlaObs">
            <td>{{ item.idPlaObs }}</td>
            <td>{{ item.descripcion }}</td>
            <td>{{ item.observacionDescripcion }}</td>
            <td>{{ obtenerTipoObservacion(item.observacionTipo) }}</td>
            <td>{{ item.planillaNombre }}</td>
            <td>{{ item.estado === "1" ? "Activo" : "Inactivo" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";

export default {
  setup() {
    const route = useRoute();
    const p_idTramite = route.params.p_idtramite;
    const observaciones = ref([]);
    const loading = ref(true);
    const error = ref(null);

    const fetchObservaciones = async () => {
      try {
        const response = await api.delete(`/vwplaobss/idtramite/${p_idTramite}`
        );
        observaciones.value = response.data.item || [];
      } catch (err) {
        error.value = "Error al obtener los datos";
      } finally {
        loading.value = false;
      }
    };

    const obtenerTipoObservacion = (tipo) => {
      const tipos = { P: "Procedimiento", D: "Documento" };
      return tipos[tipo] || "Desconocido";
    };

    onMounted(fetchObservaciones);

    return { observaciones, loading, error, obtenerTipoObservacion };
  },
};
</script>

<style scoped>
.container {
  max-width: 900px;
  margin: auto;
  padding: 20px;
}
</style>
